import { createUseBrokerWs } from '~/stores/use-broker-ws/useBrokerWs';

export const useTradingBrokerWs = createUseBrokerWs();
